var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prompt',{attrs:{"title":`${_vm.$t(`title`)} (${_vm.$t(`receiptCarrierType.${_vm.receiptCarrier}`)})`,"label":_vm.label,"defaultValue":_vm.defaultValue,"inputType":"text","placeholder":_vm.placeholder,"validator":_vm.validator},on:{"confirm":v => _vm.setOrderParams({ receiptCarrierId: v })}})
}
var staticRenderFns = []

export { render, staticRenderFns }